import { Label } from 'reactstrap';

const LabelField = ({ name, required, className }: any) => {
  return (
    <Label className={`mb-1 text-start search-label text-muted ${className}`}>
      {name}
      {required &&
        <span role="alert" className='required-field' style={{ fontSize: '14px' }}>*</span>
      }
    </Label>
  );
};

export default LabelField;
